import { OptionOrderDto } from "../hooks/binance-options-data-service/types/OptionOrderDto";
import { OptionOrder } from "../types/OptionOrder";

export const mapOptionOrders = (dtos: OptionOrderDto[]): OptionOrder[] =>
    dtos.map(mapOptionOrder);

export const mapOptionOrder = (dto: OptionOrderDto): OptionOrder => ({
    orderId: dto.orderId,
    symbol: dto.symbol,
    price: dto.price,
    size: dto.quantity,
    side: dto.side,
    createTime: dto.createTime,
});
